/**
 * <rtc-color-guard form-id="..."> - Ready to Carry parent (see snippets/rtc-child-color-map.liquid).
 *
 * The parent's selected_or_first_available_variant (or a ?variant= link) can land on a color the child bag
 * does not offer, or has sold out while sold out values are hidden. Liquid still renders that swatch, checked
 * and marked data-rtc-hidden; this element moves the selection to the first color marked data-rtc-available,
 * through the picker's own input, so the regular variant:change / section rerender runs.
 * Nothing is switched when no color is available: the product then shows as sold out.
 */
if (!window.customElements.get("rtc-color-guard")) {
  class RtcColorGuard extends HTMLElement {
    connectedCallback() {
      if (this.hasAttribute("no-shared-colors")) {
        console.warn("[rtc-color-guard] The child bag (custom.add_bag) shares no color with this product.");
      }

      // The variant picker listens for "change" once it is upgraded; wait for it before switching.
      window.customElements.whenDefined("variant-picker").then(() => {
        requestAnimationFrame(() => this.guard());
      });
    }

    guard() {
      const picker = this.closest("variant-picker");
      if (!this.isConnected || !picker) return;

      const formSelector = `[form="${CSS.escape(this.getAttribute("form-id") || "")}"]`;
      const hiddenInput = picker.querySelector(`input[data-rtc-hidden]${formSelector}:checked`);
      if (!hiddenInput) return;

      const target = picker.querySelector(
        `input[data-rtc-available]${formSelector}[name="${CSS.escape(hiddenInput.name)}"]:not(:disabled)`
      );
      if (!target) return;

      target.checked = true;
      target.dispatchEvent(new Event("change", { bubbles: true }));
    }
  }

  window.customElements.define("rtc-color-guard", RtcColorGuard);
}
